import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NowPaymentsWidget } from '../components/payment/NowPaymentsWidget';
import { api } from '../services/api';

export default function PaymentPage() {
  const { t } = useTranslation();
  const { orderId } = useParams();
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadOrder = useCallback(async () => {
    if (!orderId) {
      setError(t('payment.orderNotFound'));
      setLoading(false);
      return;
    }

    try {
      const data = await api.getPaymentOrder(orderId, { refresh: true });
      if (data.code !== 'SUCCESS' || !data.data) {
        setError(t('payment.orderLoadFailed'));
        return;
      }

      setConfig({
        payment_order_id: data.data.id || orderId,
        amount: data.data.expected_amount,
        currency: data.data.token?.toUpperCase() || data.data.currency,
        pay_address: data.data.pay_address,
        pay_uri: data.data.pay_uri,
        chain: data.data.chain,
        token: data.data.token,
        expires_at: data.data.expires_at,
        status: data.data.display_status || data.data.status,
      });
      setError(null);
    } catch (err) {
      console.error('Failed to load payment order:', err);
      setError(t('payment.orderLoadFailed'));
    } finally {
      setLoading(false);
    }
  }, [orderId, t]);

  useEffect(() => {
    loadOrder();
  }, [loadOrder]);

  if (loading) {
    return (
      <div className="min-h-screen bg-surface/95 text-white flex items-center justify-center px-6 py-10">
        <div className="animate-pulse text-gray-400">{t('common.loading')}</div>
      </div>
    );
  }

  if (error || !config) {
    return (
      <div className="min-h-screen bg-surface/95 text-white flex items-center justify-center px-6 py-10">
        <div className="text-center">
          <div className="text-lg font-semibold">{t('common.error')}</div>
          <div className="text-sm text-gray-400 mt-2">{error || t('payment.orderNotFound')}</div>
        </div>
      </div>
    );
  }

  return <NowPaymentsWidget config={config} variant="page" />;
}
